import { jsx as o, jsxs as d } from "react/jsx-runtime";
import e from "./video-modal.module.less.js";
import { useRef as p, useState as f, useEffect as h } from "react";
import v from "../../../_virtual/youtube.js";
import { Modal as y } from "../modal/modal.js";
const x = ({
  isOpen: a = !1,
  portalContainer: i,
  close: n,
  videoUrl: r,
  youtubeVideoId: s,
  onEscapeKeyDown: l
}) => {
  const t = p(null), [c, m] = f(0);
  h(() => {
    t.current && (a || m(t?.current?.currentTime));
  }, [a]);
  const u = () => {
    t.current && setTimeout(() => {
      t?.current?.play();
    }, 300);
  };
  return /* @__PURE__ */ o(
    y,
    {
      isOpen: a,
      onEscapeKeyDown: l,
      close: n,
      portalContainer: i,
      modalOverlayClassName: e.modalOverlay,
      children: /* @__PURE__ */ o("div", { className: e.innerWrapper, children: (r || s) && /* @__PURE__ */ o("div", { className: e.videoWrapper, children: /* @__PURE__ */ d("div", { className: [e.innerVideoWrapper, r ? e.nativeVideo : ""].join(" "), children: [
        r && /* @__PURE__ */ o(
          "video",
          {
            onCanPlay: u,
            ref: t,
            src: r + "#t=" + c,
            preload: "auto",
            className: e.video,
            controls: !0
          }
        ),
        !r && s && /* @__PURE__ */ o(
          v,
          {
            width: "100%",
            height: "100%",
            playing: !0,
            controls: !0,
            url: `https://www.youtube.com/watch?v=${s}`
          }
        )
      ] }) }) })
    }
  );
};
export {
  x as VideoModal,
  x as default
};
